import { render, staticRenderFns } from "./ListQuizzes.vue?vue&type=template&id=eb1067c8&scoped=true&"
import script from "./ListQuizzes.vue?vue&type=script&lang=js&"
export * from "./ListQuizzes.vue?vue&type=script&lang=js&"
import style0 from "./ListQuizzes.vue?vue&type=style&index=0&id=eb1067c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1067c8",
  null
  
)

export default component.exports